<template>
  <dx-popup
    :visible.sync="_visible"
    :drag-enabled="false"
    :close-on-outside-click="true"
    title="Hjelp og forklaringer"
  >
    <div style="position: relative; height: 100%;">
      <dx-scroll-view>
        <h2>
          <i class="fas fa-info-circle" style="margin-right: 12px; color: hsl(207, 57%, 41%);"></i>
          Kort forklaring på Ørn Elhub
        </h2>
        <ul style="list-style-type: square;">
          <li>Dette er ikke Elhub.</li>

          <li v-if="isEmployee">
            Her vises alle målere med målepktID (EAN) som er registrert i Ørns database for den aktuelle kunden.
            Det er målere som enten ligger i Ørn Optima Energi eller der Ørn har kontroll av kundens strømfakturaer.
          </li>
          <li v-if="!isEmployee">
            Her vises alle strømmålere som er registrert i Ørns database for den aktuelle kunden.
            Det er målere som enten ligger i Ørn Optima Energi eller der Ørn har kontroll av kundens strømfakturaer.
          </li>

          <li>Du kan filtrere hver kolonne ved å klikke på filtreringsikonet i øverste rad og så velge hva du vil se.</li>

          <li v-if="isEmployee">Tøm filter nullstiller alle filter.</li>

          <li v-if="isEmployee">
            Oppfrisk data oppdaterer de data du ser i bildet slik at alle endringer siden de ble hentet fram på skjermen din, er med.
          </li>

          <li>Kryss av for "Vis juridisk eier" for å se hvilket firma som eier måleren og mottar strømregninga.</li>

          <li>Søk - her kan du søke på tvers av alle felter, f.eks. siste 4 siffer i målepktID eller del av byggnavn.</li>

          <li v-if="!isEmployee">Data på siden oppfriskes ikke av seg selv. Trykk F5 eller på oppfrisk-symbolet i nettleseren.</li>
        </ul>
        <i>NB! Det kan ta noen minutter fra man godkjenner en måler i Elhub til status oppdateres hos Ørn.</i>
        <br>
        <h3>Hva viser kolonnene?</h3>
        <ul>

          <li>
            <strong>Bygg</strong>
          </li>
          <ul>
            <li>Viser byggene slik de er navngitt hos Ørn</li>
          </ul>

          <li>
            <strong>Måler</strong>
          </li>
          <ul>
            <li>Viser navnet på abonnementet hos Ørn</li>
          </ul>

          <li v-if="!isEmployee">
            <strong>MålepunktID</strong>
          </li>
          <ul v-if="!isEmployee">
            <li>
              Dette er det unike nummeret på måleren.
              Det fins på strømfakturaene, men står ikke på måleren.
              Strømleverandøren kan oppgi målepunktID dersom man har målernummeret som står på måleren
            </li>
          </ul>

          <li v-if="isEmployee">
            <strong>Målepunkt status</strong>
          </li>
          <ul v-if="isEmployee">
            <li>
              <i>Aktiv</i>
              – måleren har status aktiv</li>
            <li>
              <i>Ikke EOS/fakturakontroll</i>
              – måleren ligger verken i Ørn Optima Energi eller på fakturakontroll hos Ørn
            </li>
            <li>
              <i>Inaktiv kunde</i>
              – kunden har ikke status Betalende eller Potensiell
            </li>
            <li>
              <i>Ingen aktive målere</i>
              – bygget ligger i Optima, men det fins ingen EOS-måler som tilsvarer dette abonnementet
            </li>
            <li>
              <i>Solgt bygg</i>
              – bygget er merket «solgt» som betyr at kunden ikke eier/forvalter dette bygget lenger
            </li>
            <li>
              <i>Stengt abonnement</i>
              – Abonnementet er merket stengt i Ørns database
            </li>
          </ul>

          <li>
            <strong>Juridisk eier</strong>
          </li>
          <ul>
            <li v-if="isEmployee">
              Navn på firma som eier måleren, slik det er registrert i Elhub.
              Ørn har fått denne info fra Elhub som et engangstilfelle i konverteringsprosessen.
              Seinere får vi ikke denne info på målere vi ikke har godkjenning for.
            </li>

            <li v-if="!isEmployee">
              Navn på firma som eier måleren, slik det er registrert i Elhub. Dette fins kun for en del målere.
            </li>
          </ul>

          <li>
            <strong>Status</strong>
          </li>
          <ul>
            <li>
              <i>Tom status (Blanks)</i> betyr at måleren ikke er forespurt mot Elhub
            </li>
            <li>
              <i>Feil</i> – Elhub har svart at den ikke kjenner til måleren; - MålepktID kan være feil, mangle noen siffer el.l. Det kan være at måleren ikke finnes mer, f.eks. fordi bygget er revet eller bygd om.
            </li>
            <li>
              <i>Fjerner godkjenning</i> – Ørn har meldt til Elhub at vi ikke skal ha data for denne måleren lenger
            </li>
            <li>
              <i>OK</i> – Juridisk eier av måleren har godkjent i Elhub at Ørn skal ha tilgang til data
            </li>
            <li>
              <i>Stoppet</i> – Ørn har fått melding fra Elhub om at godkjenningen vår er stoppet for måleren. Det skjer alltid ved eierskifte på måler, eller ved at juridisk eier har fjernet tilgangen
            </li>
            <li>
              <i>Venter på godkjenning</i> – Ørn har sendt forespørsel til Elhub om tredjepartstilgang på måleren, og den venter på godkjenning fra juridisk eier
            </li>
          </ul>

          <li>
            <strong>Dato</strong>
          </li>
          <ul>
            <li>Viser dato for siste hendelse på måleren</li>
            <li>Trykk på Status-feltet i raden for oversikt over alle hendelser på måleren</li>
          </ul>

          <li>
            <strong>Elhub</strong>
          </li>
          <ul>
            <li>
              <i>Hake (true)</i> betyr at Ørn er eller har vært i dialog med Elhub om måler  - se hva målepunkt status sier
            </li>
            <li>
              <i>Ikke haket av (false)</i> betyr at måleren ikke er meldt til Elhub
            </li>
          </ul>

        </ul>

      </dx-scroll-view>
    </div>
  </dx-popup>
</template>

<script>
  import DxPopup from 'devextreme-vue/popup';
  import DxScrollView from 'devextreme-vue/scroll-view';

  export default {
    name: 'ElhubHelpPopup',
    props: ['visible'],
    components: {
      DxPopup,
      DxScrollView
    },
    computed: {
      _visible: {
        get() {
          return this.visible
        },
        set(value) {
          this.$emit('update:visible', value);
        }
      },
      isEmployee() {
        return this.$user.type === 'EMPLOYEE';
      }
    },
  };
</script>

<style scoped>

</style>
